module.exports = __webpack_public_path__ + "static/mabry-light-pro-7550c95c6b10537dbd28c553f6061d70.woff";